var _classCallCheck = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/createClass");

var Gateway =
/*#__PURE__*/
function () {
  "use strict";

  function Gateway() {
    _classCallCheck(this, Gateway);
  }

  _createClass(Gateway, [{
    key: "isAvailable",
    value: function isAvailable() {
      return false;
    }
  }, {
    key: "getNetworks",
    value: function getNetworks() {
      return [];
    }
  }, {
    key: "send",
    value: function send(network, params) {
      throw new Error('send() not implemented');
    }
  }, {
    key: "stop",
    value: function stop() {}
  }]);

  return Gateway;
}();

module.exports = Gateway;